import { logError } from 'utils/helpers';

export const zipcodeCleaningValidation = (val: string) => {
  try {
    const cleanedVal = val.replace(/[^0-9]/g, '').substring(0, 5);
    return cleanedVal;
  } catch (err) {
    logError((err as Error).message, {
      method: 'zipcodeCleaningValidation',
    });
    return val;
  }
};
